
import { Component } from "@angular/core";
import { RouterOutlet, RouterLink } from "@angular/router";
import {ApplicantAdminWelcomeComponent } from "./welcome/welcome.component";
import { ResetPassDialogComponent } from "../authentication/reset-pass-dialog/reset-pass-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
selector: 'app-applicant-admin-dashboard',
  standalone: true,
  templateUrl: './applicant-admin-dashboard.component.html',
  styleUrl: './applicant-admin-dashboard.component.scss',
  imports: [ApplicantAdminWelcomeComponent, RouterOutlet, RouterLink],
})
export class ApplicantAdminDashboardComponent {
  constructor(private dialog: MatDialog) {}
  ngOnInit(): void {
    const storedUser = sessionStorage.getItem("currentUser");
    const user = storedUser ? JSON.parse(storedUser) : null;
    if (user && user.shouldRenewPassword) {
      this.onPassChange();
    }
  }
  private onPassChange() {
    const dialogConfig = this.dialog.open(ResetPassDialogComponent, {
      minWidth: "650px",
      width: "800px",
      maxHeight: "90vh",
      disableClose: true,
    });
    dialogConfig.afterClosed().subscribe((results) => {});
  }
}


